import * as tslib_1 from "tslib";
import { DiffuseBasicMethod } from "./DiffuseBasicMethod";
/**
 * DiffuseGradientMethod is an alternative to DiffuseBasicMethod in which the shading can be modulated with a gradient
 * to introduce color-tinted shading as opposed to the single-channel diffuse strength. This can be used as a crude
 * approximation to subsurface scattering (for instance, the mid-range shading for skin can be tinted red to similate
 * scattered light within the skin attributing to the final colour)
 */
var DiffuseGradientMethod = (function (_super) {
    tslib_1.__extends(DiffuseGradientMethod, _super);
    /**
     * Creates a new DiffuseGradientMethod object.
     * @param gradient A texture that contains the light colour based on the angle. This can be used to change
     * the light colour due to subsurface scattering when the surface faces away from the light.
     */
    function DiffuseGradientMethod(gradient) {
        var _this = _super.call(this) || this;
        _this._gradient = gradient;
        _this.iAddTexture(_this._gradient);
        return _this;
    }
    Object.defineProperty(DiffuseGradientMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return DiffuseGradientMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiffuseGradientMethod.prototype, "gradient", {
        /**
         * A texture that contains the light colour based on the angle. This can be used to change the light colour
         * due to subsurface scattering when the surface faces away from the light.
         */
        get: function () {
            return this._gradient;
        },
        set: function (value) {
            if (this._gradient == value)
                return;
            if (this._gradient)
                this.iRemoveTexture(this._gradient);
            this._gradient = value;
            if (this._gradient)
                this.iAddTexture(this._gradient);
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    return DiffuseGradientMethod;
}(DiffuseBasicMethod));
export { DiffuseGradientMethod };
DiffuseGradientMethod.assetType = "[asset DiffuseGradientMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/DiffuseGradientMethod.js